'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Search } from '../Icons';
import { Button, Form, IconWrapper, Input } from './styles';
export const SearchForm = ({ initialValue, onSubmit, placeholderLabel, }) => {
    const [value, setValue] = React.useState(initialValue);
    const onInputChange = React.useCallback((event) => {
        setValue(event.target.value);
    }, []);
    const onFormSubmit = React.useCallback((event) => {
        event.preventDefault();
        onSubmit(value);
    }, [value, onSubmit]);
    return (_jsxs(Form, { onSubmit: onFormSubmit, children: [_jsx(Input, { value: value, onChange: onInputChange, "aria-label": placeholderLabel, placeholder: placeholderLabel }), _jsx(Button, { type: 'submit', onMouseDown: e => e.preventDefault(), children: _jsx(IconWrapper, { children: _jsx(Search, {}) }) })] }));
};
//# sourceMappingURL=SearchForm.js.map